"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NO_ACCUMULATION_THRESHOLDS = void 0;
exports.getFederalAccumulationThresholds = getFederalAccumulationThresholds;
const wasteGeneratorStatusThresholds_1 = require("encamp-shared/dist/constants/wasteGeneratorStatusThresholds");
exports.NO_ACCUMULATION_THRESHOLDS = {
    totalKg: null,
    nonAcuteKg: null,
    acuteKg: null,
};
/**
 * Federal on-site quantity caps (40 CFR 262.14/262.16): VSQGs are capped per
 * classification (1,000 kg non-acute AND 1 kg acute), SQGs by a single
 * 6,000 kg total, and LQGs not at all (time-limited instead).
 */
function getFederalAccumulationThresholds(generatorStatus) {
    switch (generatorStatus) {
        case "VSQG":
            return {
                totalKg: null,
                nonAcuteKg: wasteGeneratorStatusThresholds_1.VSQG_ACCUMULATION_THRESHOLD_KG,
                acuteKg: wasteGeneratorStatusThresholds_1.VSQG_ACCUMULATION_THRESHOLD_ACUTE_KG,
            };
        case "SQG":
            return { totalKg: wasteGeneratorStatusThresholds_1.SQG_ACCUMULATION_THRESHOLD_KG, nonAcuteKg: null, acuteKg: null };
        // LQGs have no accumulation threshold; an unresolvable status gets none either —
        // the caller prompts for setup rather than assuming a status.
        default:
            return exports.NO_ACCUMULATION_THRESHOLDS;
    }
}
//# sourceMappingURL=onSiteAccumulationThresholds.js.map